import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  root: {
      height: '100%'
  },
}));

export default styles;
